import React from "react";
import Select from 'react-select';
import NumberFormat from 'react-number-format';

import * as TICKS from './../../data/tickers';
import {SECTOR_COLOR} from './../constant';
import {abbreviateNumber} from './../../utils/time';


class SearchForm extends React.Component {

    onSelect(item, action){
        const ticker = item.value;
        this.props.onTickerSelect(ticker);
      }

      
    render (){
        var tick_list = []
        const tickers = Object.keys(TICKS);
        for(var i=0; i< tickers.length; i++){
            if (!TICKS[tickers[i]].longName){
                continue;
            }
            tick_list.push({
                'label': "[" + tickers[i] + "] " + TICKS[tickers[i]].longName,
                'value': tickers[i],
            })
        }
        tick_list.sort((a,b) => {
            if (a.value < b.value) {
                return -1;
            }
            if (a.value > b.value) {
                return 1;
            }
            return 0;
        })
        
        return (
            <div className="row">
                <div className="col-md-6">
                    <Select 
                        options={tick_list} 
                        onChange={this.onSelect.bind(this)}
                        placeholder="Pick a ticker"
                    />
                    <p className="small text-muted">Modify this portfolio by adding your own tickers</p>
                </div>
            </div>
        )
    }
}

export default class Component extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        search_text: null,
        results: [],
        exists: false,
        stocks: this.props.stocks,
      }
    }

    onTickerSelect(ticker){
        const state = this.state;
        state.stocks.push({'ticker': TICKS[ticker], "shares": 0});
        this.setState(state);
    }
  
    onInputChange(e){
      e.preventDefault();
      const state = this.state;
      state.search_text = e.target.value.toUpperCase();
      if (state.search_text !== null & state.search_text.length >= 1) {
          const results = Object.keys(TICKS).filter(k => k === state.search_text);
          state.exists = (results.length >= 1);
          state.results = Object.keys(TICKS).filter(k => k.startsWith(state.search_text));
      } else {
        state.exists = false;
        state.results = [];
      }
      this.setState(state);
    }
  
    render(){
  
        const net_equity = this.props.net_equity;
        const editable = this.props.editable || false;
        
        const stocks = this.state.stocks;

        let sum_weight = 0;
        let total_equity = 0;
        let total_annual_dividend = 0;
        const total_weight = stocks.reduce(function(sum, stock){return sum+stock['weight'] }, 0);

        stocks.map(function(ticker_dict, idx){
            const ticker = ticker_dict['ticker'];
            const avg_price = (ticker.open? (ticker.open.toFixed(2)): ticker.open);
            var equity = (ticker_dict['shares'] === undefined)? (parseInt((ticker_dict['weight'] / total_weight) * net_equity)): (ticker_dict['shares']*avg_price);
            total_equity += equity;
            const annual_dividend = ((ticker.open*ticker.dividendRate)/100) * (equity/ticker.open);
            // console.log(ticker.symbol+' - '+ticker.open+' - '+ticker.dividendRate);
            
            total_annual_dividend += annual_dividend;
        })

        return (
        <div className="text-black">
        <table className="table table-hover">
            <thead>
            <tr className="">
                <th className=""></th>
                <th className="">Name</th>
                <th className="text-center">Ticker</th>
                <th className=""></th>
                <th className="">Sector</th>
                <th className="">Cap</th>
                <th className="">Avg Price</th>
                <th className="">Div %</th>
                <th className="">Weight</th>
                <th className="text-center">Shares</th>
                <th className="">Invested</th>
                <th className="">Dividend</th>
                {(editable)? (<th className=""></th>): <React.Fragment/>}
            </tr>
            </thead>
            <tbody>
            {stocks.map(function(ticker_dict, idx){

                const ticker = ticker_dict['ticker'];
                const m_cap = ticker.marketCap || ticker.totalAssets;
                const avg_price = (ticker.open? (ticker.open.toFixed(2)): ticker.open);
                const equity = (ticker_dict['shares'] === undefined)? (parseInt((ticker_dict['weight'] / total_weight) * net_equity)): (ticker_dict['shares']*avg_price);
                const annual_dividend = ((ticker.open*ticker.dividendRate)/100) * (equity/ticker.open);

                // console.log(ticker.symbol + " - " + ticker.open + " - " + equity + " - " + ticker.dividendRate + " - " + annual_dividend);
                
                const weight = ((equity/total_equity) * 100);
                sum_weight += weight;

                return (
                <tr key={idx} className="small">
                    <th className=""><img src={ticker.logo_url} alt="" className="" style={{height: "20px", width: "20px"}} /></th>
                    <th className="">{ticker.symbol}</th>
                    <td><a href={ticker.website} className="">{ticker.longName}</a></td>
                    <th className="rounded m-1" style={{backgroundColor: SECTOR_COLOR[ticker.sector]}} ></th>
                    <th className="text-black-6">{(ticker.sector)? ticker.sector: '-'}</th>
                    <td className="text-black-6">{abbreviateNumber(m_cap)}</td>
                    <td className="text-black-6"><NumberFormat value={avg_price} fixedDecimalScale decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                    <td className="text-black-6">{(ticker.dividendRate)? (ticker.dividendRate.toFixed(2)+'%'): ticker.trailingAnnualDividendRate}</td>
                    <td className="text-black-1">{(editable)? (<input type="text" className=""/>): (<span className="">{weight.toFixed(2)}%</span>)}</td>
                    <td className="text-black-1">
                        <div className="px-3">
                            <input data-ticker={ticker.symbol} data-shares={ticker_dict['shares']} onChange={this.props.onShareChange} className="form-control form-control-sm text-size-2" value={ticker_dict['shares']}/>
                        </div>
                    </td>
                    <td className="text-black-3"><NumberFormat value={equity} fixedDecimalScale decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                    <td className="text-black-3">
                        <a href={"https://www.nasdaq.com/market-activity/stocks/" + ticker.symbol + "/dividend-history"} className="">
                            <NumberFormat value={annual_dividend} fixedDecimalScale decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                        </a>
                    </td>
                    {(editable)? (<td className=""><button className="btn btn-sm btn-danger"><i className="fa fa-trash mx-1"></i></button></td>): <React.Fragment/>}
                </tr>
                )
            }, this)}
                <tr>
                    <th className=""></th>
                    <td className="strong"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{sum_weight.toFixed(2)}%</td>
                    <td></td>
                    <td className="strong"><NumberFormat value={total_equity} fixedDecimalScale decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                    <td className="strong"><NumberFormat value={total_annual_dividend} fixedDecimalScale decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                    {(editable)? (<td></td>): <React.Fragment/>}
                </tr>
            </tbody>
        </table>

        <div className="my-2 mb-5">
            <SearchForm onTickerSelect={this.onTickerSelect.bind(this)} />
        </div>

        {(editable)? (
            <SearchForm onInputChange={this.onInputChange.bind(this)} results={this.state.results} exists={this.state.exists} />
        ): ''}

            <div className="disclaimer small strong text-muted">
                <div className="">
                    <i className="fa fa-asterisk mr-2 small"></i> Portfolios are only meant as examples to show the type of stocks and diversification required to build a dividend compounding portfolio. It is not investment advice!
                </div>
                <div className="">
                    <i className="fa fa-asterisk mr-2 small"></i> The prices shown here are updated with a delay. Please use other resources for accurate / updated price.
                </div>
            </div>

        </div>

        )
    }
}

// Disclosure:  Some of the links on this page are referral links. At no additional cost to you, if you choose to make a purchase or sign up for a service after clicking through those links, I may receive a small commission. This allows me to continue producing high-quality, ad-free content on this site and pays for the occasional cup of coffee